// ===========================================
// Late fees as a FAMILY sees them (#372 plan A6.3, study §12(5))
// ===========================================
// Each fee on its own line. A waived fee stays, struck through, as "Late fee (waived)": it no
// longer counts. Never a reason or who waived it (the parent routes do not send them).

import { Box, Typography } from '@mui/material';
import type { InvoiceLateFee } from '../../api/invoices.api';
import { formatCurrencyFromDollars } from '../../utils/currency';
import { formatInSchoolTz } from '../../utils/dateUtils';

const DAY: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };

export interface FamilyLateFeeLinesProps {
  fees: InvoiceLateFee[] | undefined;
  timeZone: string;
}

export default function FamilyLateFeeLines({ fees, timeZone }: FamilyLateFeeLinesProps) {
  if (!fees || fees.length === 0) return null;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }} data-testid="family-late-fees">
      {fees.map((fee) => {
        const waived = fee.waivedAt !== null;
        return (
          <Box key={fee.id} sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" color="text.secondary">
              {waived ? 'Late fee (waived)' : `Late fee, added ${formatInSchoolTz(fee.appliedAt, timeZone, DAY)}`}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={waived ? { textDecoration: 'line-through' } : undefined}
            >
              {formatCurrencyFromDollars(parseFloat(fee.amount))}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
